enum PensionAgreementGrouping {
  SELF = 'SELF',
  EMPLOYER = 'EMPLOYER',
  STATE = 'STATE',
  UNDEFINED = 'UNDEFINED',
}

export default PensionAgreementGrouping;
